import { OrganizationRoleEntity } from '../entities/OrganizationRole';
import { authResource } from './Auth';
export const OrganizationRoleResource = authResource({
    path: '/organizations/:organizationId/roles/:organizationRoleId',
    schema: OrganizationRoleEntity
});
